export default __webpack_public_path__ + "static/media/device.ac9a096d.svg";